import { render, staticRenderFns } from "./ProcessProduct.vue?vue&type=template&id=bf5a74c6&scoped=true"
import script from "./ProcessProduct.vue?vue&type=script&lang=js"
export * from "./ProcessProduct.vue?vue&type=script&lang=js"
import style0 from "./ProcessProduct.vue?vue&type=style&index=0&id=bf5a74c6&prod&lang=sass&scoped=true"
import style1 from "./ProcessProduct.vue?vue&type=style&index=1&id=bf5a74c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5a74c6",
  null
  
)

export default component.exports